let IntentosPost7 = 0;
const PostXlsUploadHist = (url, content, resp) => {
    let data = new FormData();
    data.append('archivo', content.file.files[0]);
    data.append('carrera', content.carrera);
    data.append('est', content.est);
    data.append('uId', content.uId);
    data.append('usu', content.usuario);
    
    fetch(url, {
        method: 'POST', 
        body: data,
        /* credentials: "same-origin" */})
    .then(response => {
        response.text().then(respuesta);
        function respuesta(data) {
            resp (data);
        }
    },error => {
        IntentosPost7++;
        (IntentosPost7 > 5) ? IntentosPost7 = 0 : PostXlsUploadHist(url, content, (respuesta) => {
            resp(respuesta)
        })
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })
}

export default PostXlsUploadHist;


// WEBPACK FOOTER //
// ./src/shared/PostXlsUploadHist.jsx